/**
 * use-adapty-product-links.ts — Adapty 内部 product_id ↔ 逻辑产品 access_level_id 手动关联 API 封装
 *
 * 对应后端 /api/v1/adapty-product-links/*（operator+）：admin 独有关联表，把 server-side 镜像产品(adapty_product_id)
 * 关联到我方逻辑产品(access_level_id)，替掉「按标题启发式判已录入」的弱校验。每方法 = 一次 apiRequest（自动带 JWT +
 * 解 envelope 返 data）。请求/响应类型一律从 @novel-admin/shared 取。
 */

import type {
  AdaptyProductLinkResponse,
  UpsertAdaptyProductLinkRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const adaptyProductLinksApi = {
  /** 列某 App 全部 active 关联（per-App 有界集） */
  list: (appId: string) =>
    apiRequest<AdaptyProductLinkResponse[]>({
      method: 'GET',
      path: '/api/v1/adapty-product-links',
      query: { app_id: appId },
    }),
  /** 建立固定关联（按 (app_id, adapty_product_id) 关联到 access_level_id；active 关联不改值，A8 §8.3） */
  upsert: (body: UpsertAdaptyProductLinkRequest) =>
    apiRequest<AdaptyProductLinkResponse>({
      method: 'POST',
      path: '/api/v1/adapty-product-links',
      body,
    }),
  /** 解除关联（软删；该产品已有渠道行时服务端 RESOURCE_CONFLICT 拒绝） */
  remove: (id: string) =>
    apiRequest<{ id: string; deleted_at: string }>({
      method: 'DELETE',
      path: `/api/v1/adapty-product-links/${id}`,
    }),
};
